// extracted by mini-css-extract-plugin
module.exports = {"image":"clinical-portal-3__ProfileImage__image"};